var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-less {\r\n        fill: #ffcf04;\r\n        stroke-width: 0px;\r\n      }\r\n      .white-class{\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-less",
    d: "M55.28,1.97C25.88,1.97,1.97,25.88,1.97,55.28s23.91,53.3,53.3,53.3,53.3-23.91,53.3-53.3S84.67,1.97,55.28,1.97ZM55.28,101.92c-25.72,0-46.64-20.92-46.64-46.64S29.56,8.63,55.28,8.63s46.64,20.92,46.64,46.64-20.92,46.64-46.64,46.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "white-class",
    d: "M78.6,51.94H31.95c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h46.64c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenos);
export default __webpack_public_path__ + "static/media/menos.80d82581c8851e74cedaa858ccedd006.svg";
export { ForwardRef as ReactComponent };